import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import DomainConnectModal from '@/components/domain_connect/DomainConnectModal.vue';
import { setupVueI18n } from '@/plugin/vue-i18n';
import { DOMAIN_CONNECT_PRODUCT_TYPES, } from '@/types';
import '@gohighlevel/ghl-ui/dist/style.css';
import { onUnmounted, provide, reactive, ref } from 'vue';
import '../index.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DomainConnect',
    props: {
        route: Object,
        router: Object,
        emitter: Object,
        store: Object,
        locale: String,
    },
    setup(__props) {
        var _a;
        const props = __props;
        setupVueI18n(props.locale);
        // inject current route
        provide('route', props.route);
        provide('router', props.router);
        provide('emitter', props.emitter);
        provide('store', props.store);
        /* DON't write any direct logics here because if we use
        composition here it won't be able to access providers
        */
        const showModal = ref(false);
        const configuration = reactive({
            team: DOMAIN_CONNECT_PRODUCT_TYPES.FUNNELWEBSITE,
            addRootOrWWW: true,
            prefillDomain: undefined,
        });
        const closeDomainConnectModal = () => {
            showModal.value = false;
        };
        onUnmounted(() => {
            closeDomainConnectModal();
        });
        (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.on('domain-connect-show', (payload) => {
            var _a, _b;
            showModal.value = true;
            configuration.team = payload.team;
            configuration.addRootOrWWW = (_a = payload === null || payload === void 0 ? void 0 : payload.addRootOrWWW) !== null && _a !== void 0 ? _a : false;
            configuration.prefillDomain = (_b = payload === null || payload === void 0 ? void 0 : payload.prefillDomain) !== null && _b !== void 0 ? _b : undefined;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DomainConnectModal, {
                configuration: configuration,
                showModal: showModal.value,
                onClose: closeDomainConnectModal
            }, null, 8, ["configuration", "showModal"]));
        };
    }
});
